export function resolveMarketingConsent(value?: boolean | null): boolean {
  return value !== false;
}
